import styled from 'styled-components'
import {
  PRIMARY_RED_01,
  PRIMARY_RED_09,
} from 'bd-web-components/src/utils/dash-colors'

export const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #ffffff;
  border: 0.8px solid #e5e5e5;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #d4d4d4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  min-width: 46px;
  height: 46px;
  border-radius: 11px;
  background-color: ${PRIMARY_RED_09};

  img {
    width: 22px;
    height: 22px;
  }
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const CardTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CardTitle = styled.div`
  color: #0a0a0a;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

export const CardBadge = styled.span`
  background-color: ${PRIMARY_RED_01};
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  line-height: 14.5px;
  padding: 2px 8px;
  border-radius: 9999px;
  white-space: nowrap;
`

export const CardDescription = styled.div`
  color: #737373;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  padding-top: 5px;
`

export const Chevron = styled.img`
  align-self: center;
  width: 18px;
  height: 18px;
`
